import { Controller } from '@hotwired/stimulus'
import { get, put } from '../lib/request'

export default class extends Controller {
  static values = { url: String }
  static targets = ['country', 'phoneNumber']

  disconnect = () => {
    clearTimeout(this.validateTimeout)
  }

  // keeps whatever was typed so changing the country doesn't wipe the number
  generateForm = () => {
    const params = new URLSearchParams({
      country_code: this.countryTarget.value,
      phone_number: this.hasPhoneNumberTarget ? this.phoneNumberTarget.value : '',
    })

    get(`${this.urlValue}?${params}`, { responseKind: 'turbo-stream' })
  }

  validateNumber = () => {
    clearTimeout(this.validateTimeout)
    this.validateTimeout = setTimeout(this.requestValidation, 300)
  }

  requestValidation = () => {
    if (!this.hasPhoneNumberTarget) return

    const { validateUrl, countryCode } = this.phoneNumberTarget.dataset
    const params = new URLSearchParams({
      country_code: countryCode,
      phone_number: this.phoneNumberTarget.value,
    })

    put(`${validateUrl}?${params}`, { responseKind: 'turbo-stream' })
  }

  openSupport = () => {
    window.dispatchEvent(new CustomEvent('support-chat:open'))
  }
}
